import { AuditLogAction } from '@app/models/log/audit';

export const AUDIT_LOG_ACTION_LABELS: Record<AuditLogAction, string> = {
  [AuditLogAction.ACCOUNT_DISABLE]: 'Account Disabled',
  [AuditLogAction.ACCOUNT_ENABLE]: 'Account Enabled',
  [AuditLogAction.ACCOUNT_DELETE]: 'Account Deleted',
  [AuditLogAction.IMPERSONATION_START]: 'Impersonation Started',
  [AuditLogAction.PLAN_CHANGE]: 'Plan Changed',
  [AuditLogAction.USER_ROLE_CHANGE]: 'User Role Changed',
  [AuditLogAction.SUBSCRIPTION_FEATURES_CHANGED]:
    'Subscription Features Changed',
};

export const AUDIT_LOG_ACTION_OPTIONS = Object.values(AuditLogAction).map(
  (value) => ({
    value,
    label: AUDIT_LOG_ACTION_LABELS[value as AuditLogAction],
  })
);

export const getAuditLogActionColor = (action: AuditLogAction): string => {
  switch (action) {
    case AuditLogAction.ACCOUNT_DISABLE:
      return 'bg-red-100 text-red-800';
    case AuditLogAction.ACCOUNT_ENABLE:
      return 'bg-green-100 text-green-800';
    case AuditLogAction.ACCOUNT_DELETE:
      return 'bg-red-100 text-red-800';
    case AuditLogAction.IMPERSONATION_START:
      return 'bg-purple-100 text-purple-800';
    case AuditLogAction.PLAN_CHANGE:
      return 'bg-blue-100 text-blue-800';
    case AuditLogAction.USER_ROLE_CHANGE:
      return 'bg-orange-100 text-orange-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
